import { useTranslations } from 'next-intl'

interface useFlightTravellersProps {
  adult: number
  child: number
}
export const useFormatFlightTravellers = ({ adult, child }: useFlightTravellersProps) => {
  const t = useTranslations('components.traveller_picker.labels')

  const output = [t('adult_count', { count: adult })]
  if (child > 0) {
    output.push(t('child_count', { count: child }))
  }

  return output.join(', ')
}
